export const ROLES = {
  MEMBER: "member",
  ADMIN: "admin",
  SUPERADMIN: "superadmin",
  SUPPORT: "support",
  PUBLISHER: "publisher",
} as const;

export const ADMIN_ROLES = [ROLES.ADMIN, ROLES.SUPERADMIN] as const;

export const PUBLISHER_ROLES = [
  ROLES.ADMIN,
  ROLES.SUPERADMIN,
  ROLES.PUBLISHER,
] as const;
